const ApprovalCardSkeleton = () => {
  return (
    <div className="bg-white border border-border rounded-xl p-4 shadow-sm animate-pulse">
      {/* Top Section */}
      <div className="flex gap-3">
        {/* Profile Image */}
        <div className="w-14 h-14 bg-gray-200 rounded-full" />

        <div className="flex-1 space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-3 bg-gray-200 rounded w-1/2" />
          <div className="h-3 bg-gray-200 rounded w-2/5" />
        </div>
      </div>

      {/* Buttons Section */}
      <div className="mt-4 flex justify-between items-center">
        {/* View Button */}
        <div className="h-4 w-20 bg-gray-200 rounded-md" />

        <div className="flex gap-2">
          <div className="h-8 w-20 bg-gray-200 rounded-lg" />
          <div className="h-8 w-20 bg-gray-200 rounded-lg" />
        </div>
      </div>
    </div>
  );
};
export default ApprovalCardSkeleton;
